import { FC } from 'react';
import { useIntl } from 'react-intl';

import { HeaderCell } from '../../HeaderCell';
export interface HeaderProps {
  showWeight: boolean;
}

export const Header: FC<HeaderProps> = ({ showWeight }) => {
  const { formatMessage } = useIntl();

  if (!showWeight) {
    return null;
  }

  return (
    <HeaderCell className="px-0">
      <div className="d-flex flex-column">
        <label htmlFor="Weight" className="fs-6 mb-2 mt-2 ps-2">
          {formatMessage({
            id: 'quote.underlyingsGrid.header.weight',
          })}
        </label>
      </div>
    </HeaderCell>
  );
};
